import { useQuery } from '@tanstack/react-query';

import { Query } from './api';
import { QueryParams } from '../types/api.types';

export const useCatalogTags = <T = any>(options: QueryParams) => {
  const params = options || {};
  return useQuery({
    queryKey: ['catalog-tags', params],
    queryFn: async () => {
      return await new Query('catalog-tags')
        .page(params.page || 1)
        .size(params.size || 10)
        .filter(params.filter)
        .run<T>();
    },
    staleTime: 300000,
  });
};

export const useCatalogTypes = <T = any>(
  accountId: string,
  options: QueryParams,
) => {
  const params = options || {};

  return useQuery({
    queryKey: [accountId, 'catalog-types', params],
    queryFn: async () => {
      return await new Query(`accounts/${accountId}/catalog-types`)
        .page(params.page || 1)
        .size(params.size || 10)
        .filter(params.filter)
        .run<T>();
    },
    staleTime: 300000,
  });
};

export const useCatalogType = <T = any>(
  accountId?: string,
  entityType?: string,
  catalogTypeName?: string,
) => {
  return useQuery({
    queryKey: [accountId, 'catalog-types', catalogTypeName],
    queryFn: async () => {
      return await new Query(
        `accounts/${accountId}/catalog-types/${entityType}/${catalogTypeName}`,
      ).run<T>();
    },
    staleTime: 300000,
    enabled: !!entityType,
  });
};
